// import 'detect-autofill';

export default new class Input {
  constructor() {
    this.inputWrapSelector = 'input';
    this.inputWrapFilledSelector = 'input_filled';
    this.inputFieldSelector = 'input__field';
    this.inputFieldFilledSelector = 'input__field_filled';
    this.inputLabelSelector = 'input__label';
    this.errorSelector = 'validation-error';

    this.handler();
  }

  handler() {
    const inputs = document.querySelectorAll(`.${this.inputFieldSelector}`);

    if (!inputs.length) return;

    inputs.forEach(input => {
      ['blur', 'change'].forEach(event => {
        input.addEventListener(event, ({ target }) => {
          this.checkChange(target);
        });
      });
    });
  }

  static checkInputState(input) {
    const value = input.value.trim();
    return value.length > 0;
  }

  checkChange(target) {
    if (!target.hasAttribute('required')) return;

    if (target.value.trim().length > 0) {
      target.classList.add(this.inputFieldFilledSelector);
    } else {
      target.classList.remove(this.inputFieldFilledSelector);
    }
  }

  findLabel(input) {
    return input.parentElement.querySelector(`.${this.inputLabelSelector}`);
  }
}();